<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <feature-show :id="id"></feature-show>
    <polymorphic-reference-card-index
      :filtering="filtering_reference"
    ></polymorphic-reference-card-index>
  </div>
</template>

<script>
import FeatureShow from './FeatureShow.vue'
import PolymorphicReferenceCardIndex from './PolymorphicReferenceCardIndex.vue'

export default {
  components: {
    FeatureShow,
    PolymorphicReferenceCardIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering_reference: {
        reference_to_type: 'Feature',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        description: undefined,
        attributes: {
          'reference-to-type': "Feature",
          'reference-to-id': this.id
        }
      },
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
